import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-sidebar-card.css.lit';

import '../ghs-heading/ghs-heading';

/**
 * The Sidebar Card component
 *
 * @element ghs-sidebar-card
 * @slot defaultSlot - Contains the content.
 */
@customElement('ghs-sidebar-card')
export class GhsSidebarCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * The heading text.
   * @param heading
   */
  @property({ type: String })
  heading = '';

  render(): TemplateResult {
    return html`
      <div class="sidebar-card">
        ${this.heading
          ? html` <ghs-heading
              level="h3"
              level-size="3xl"
              class="sidebar-card-heading"
              site=${this.site}
            >
              ${this.heading}
            </ghs-heading>`
          : nothing}
        <slot></slot>
      </div>
    `;
  }
}
